/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';

interface AssetLibraryImageUrlWidgetArgs {
  label?: string;
  labelTooltipContent?: string;
  imageUrl: string;
  builderType: string;
  inputClassNames?: string;
  helpText?: string;
  filterFileSizeInBytes?: number;
  disabled?: boolean;
  imageUrlInputErrors?: string[];
  imageUrlInputPlaceholder?: string;
  imageUrlInputErrorType?: string;
  onImageUrlChange: (imageUrl: string) => unknown;
  onInputFocus?: () => unknown;
  onInputBlur?: () => unknown;
}

export default class AssetLibraryImageUrlWidget extends Component<AssetLibraryImageUrlWidgetArgs> {
  @tracked showAssetLibraryModal = false;
  @tracked imageUrlIsLoading = false;
  @tracked locallyLoadedObjectImageUrl = '';
  @tracked couldNotLoadImageUrlLocally = false;

  get isImageUrlValueValidUrl() {
    try {
      let url = new URL(this.args.imageUrl);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch {
      return false;
    }
  }

  get isImageUrlValueEmpty() {
    return isEmpty(this.args.imageUrl);
  }

  get imageUrlInputPlaceholder() {
    return this.args.imageUrlInputPlaceholder ?? 'or type image URL or Liquid expression';
  }

  @action
  onImageUrlChange(value: string) {
    this.args.onImageUrlChange(value);
  }

  @action
  pickFileFromAssetLibrary(imageUrl: string) {
    this.onImageUrlChange(imageUrl);
    this.showAssetLibraryModal = false;
  }

  @action
  removeImage() {
    this.onImageUrlChange('');
  }

  @action
  onInputFocus() {
    if (this.args.onInputFocus != null) {
      this.args.onInputFocus();
    }
  }

  @action
  onInputBlur() {
    if (this.args.onInputBlur != null) {
      this.args.onInputBlur();
    }
  }

  @action
  onImageLoad() {
    this.couldNotLoadImageUrlLocally = false;
  }

  @action
  onImageError() {
    this.couldNotLoadImageUrlLocally = true;
  }
}
